const getFilesText = (files: any) => {
    return new Promise((resolve) => {
        const Files = Array.from(files);

        Files.forEach((file: any): void => {
            const reader = new FileReader();
            reader.onload = (fileURL: any) => {
                resolve(fileURL.target.result);
            };
            reader.readAsBinaryString(file);
        });
    });
};

export default getFilesText;
